
import { CircularProgress } from "./CircularProgress";
import { PostUploadActions } from "./PostUploadActions";
import { Button } from "@/components/ui/button";
import { UploadCloud } from "lucide-react";

interface UploadProgressProps {
  progress: number;
  currentTotalSize: number;
  uploadComplete: boolean;
  onCopyLink: (filePath: string, transferId: string) => Promise<void>;
  onReset: () => void;
  filePath?: string;
  transferId?: string;
}

export function UploadProgress({
  progress,
  currentTotalSize,
  uploadComplete,
  onCopyLink,
  onReset,
  filePath,
  transferId
}: UploadProgressProps) {
  return (
    <div className="flex flex-col items-center">
      <CircularProgress 
        progress={progress} 
        size={240}
        strokeWidth={8}
        currentSize={currentTotalSize}
        totalSize={currentTotalSize}
      />
      {uploadComplete && filePath && transferId ? (
        <div className="mt-6 flex flex-col items-center gap-4">
          <PostUploadActions
            onCopyLink={onCopyLink}
            filePath={filePath}
            transferId={transferId}
          />
          <Button 
            onClick={onReset}
            variant="outline"
            className="bg-white/10 hover:bg-white/20 text-white border-white/20"
          >
            <UploadCloud className="mr-2 h-4 w-4" />
            Subir otro archivo
          </Button>
        </div>
      ) : (
        <p className="mt-4 text-white">
          Subiendo {(currentTotalSize / 1024 / 1024).toFixed(2)} MB...
        </p>
      )}
    </div>
  );
}
